const pathToCnMap = {
  serviceAndSupport: '服务与支持',
  achievementDisplay: '成果展示',
  detailDemand: '需求详情',
  detailDeal: '成果详情',
  openLicense: '开放许可列表',
  licenseDetailDeal: '开放许可详情',
  demandMark: '需求市场',
  tradingMarketInfos: '成果列表',
  informationAnnouncement: '交易公告管理',
  announcement: '公告列表',
  detailAnnounce: '公告详情',
  create: '新增',
  edit: '编辑',
  detail: '详情',
  TechnicalTeamDetail: '技术团队详情',
  techDetailDeal: '技术需求库详情',
  techDealInfos: '技术需求库列表',
  TechnicalRLibrary: '技术需求库',
  talentData: '人才团队',
  TechnicalTeam: '技术团队列表',
  talentList: '人才团队列表',
  talentDetail: '人才详情页',
  IndustryInformation: '产业信息服务',
  IndustryInformationList: '产业信息列表',
  IndustryInformationDetail: '产业信息列表详情页',
  IndustryNavigationList: '产业导航列表',
  IndustryNavigationDetail: '产业导航列表详情'
}

function getCurrentCrumb(path) {
  const paths = path.split('/').filter(Boolean) // 获取所有路径
  return paths.reduce((pre, cur) => {
    pre.push({
      name: pathToCnMap[cur],
      toRouter: cur
    })
    return pre
  }, [])
}

module.exports = {
  getCurrentCrumb
}
